import { gql } from '@apollo/client';

export const GENERATE_IL_DISCLOSURE_FORM = gql`
  mutation Flex_GenerateIlDisclosureForm($utilityAccountId: Int!, $redirectUri: String!) {
    generateIlDisclosureForm(utilityAccountId: $utilityAccountId, redirectUri: $redirectUri) {
      enqueued
      utilityAccountId
    }
  }
`;
